import React, {
  useState,
  useEffect,
  useCallback,
} from 'react'
import {
  requestReportSalesDaily,
  requestReportPaymentsDaily,
} from 'requests/reports'
import { SETTINGS_SUBMENU } from 'constants/menu/submenus'
import { InfoPage } from 'templates/InfoPage'
import { Alert } from 'ui-components/Alert';
import { SideMenu } from 'components/SideMenu'
import { ListSkeleton } from 'components/ListSkeleton'
import { Payments } from './components/Payments';
import { Sales } from './components/Sales';

export default function DailyReport() {
  const [sales, setSales] = useState({});
  const [payments, setPayments] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  const getSales = useCallback(async () => {
    const response = await requestReportSalesDaily()
    if (response.error) {
      setErrorMessage('Não foi possível buscar os dados da venda')
    }

    setSales(response)
  }, [])

  const getPayments = useCallback(async () => {
    const response = await requestReportPaymentsDaily()
    if (response.error) {
      setErrorMessage('Não foi possível buscar os dados dos pagamento de pedidos')
    }

    setPayments(response)
  }, [])

  useEffect(() => {
    getSales()
    getPayments()
  }, [getSales, getPayments])

  const renderMenu = () => (
    <SideMenu submenu={SETTINGS_SUBMENU} />
  )

  return (
    <InfoPage
      renderMenu={renderMenu}
      title="Resumo Diário"
      subtitle=""
    >
      <Alert>
        Valores referentes à movimentação do dia
      </Alert>

      { sales.id
        ? (
          <Sales sales={sales} />
        ) : <ListSkeleton />}

      { payments.id
        ? (
          <Payments payments={payments} />
        ) : <ListSkeleton />}
      { errorMessage }
    </InfoPage>
  )
}
